<template>
  <div>
    <BlockUI v-if="busy">
      <div class="loader"></div>
    </BlockUI>
    <div class="row">
      <div class="col-12 col-lg-12 p-0">
        <NotiPos/>
      </div>
      <div class="row" style="width: 100%">
        <div class="col-24 col-lg-12">
          <b-form-group id="input-group-1" label-for="input-search-couier">
            <b-input-group>
              <b-form-input
                  id="input-search-couier"
                  type="text"
                  v-model="searchCourier"
                  placeholder="ค้นหาขนส่ง"
                  class="mt-2 w-100"
              >
                <b-input-group-append>
                  <div class="d-flex align-items-center justify-content-center">
                    <i class="fas fa-search text-muted"></i>
                  </div>
                </b-input-group-append>
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </div>
      </div>
      <b-card-text class="p-0 scroll-bar-pop card-tab" style="width: 100%;">
        <div class="row pr-3 py-2" style="display: flex;align-items: center;justify-content: space-between;">
          <div class="col-12 col-lg-6 col-xl-8">
            <h4 class="cursor-pointer d-flex align-items-center text-color-draft">
                        <span>
                            <img :src="iconDraft.url" alt="">
                        </span>
              <span class="ml-1">
                            {{ draftLength ? `ฉบับร่าง (${countDraft()})` : "ฉบับร่าง (0)" }}
                        </span>
            </h4>
          </div>
          <div class="col-6 col-lg-6 col-xl-4 text-right">
          <!--   对比计算价格   -->
            <b-button
                id="checkPrice"
                :class="showCart !== 'non-slide' ? 'mr-4' : ''"
                variant="primary"
                size="sm"
                @click="changeStepPosPage(getStepPage.STEP_PAGE_CHECKPRICE)"
            >
              <i class="fas fa-database"></i>
              เปรียบเทียบราคา
            </b-button>
          </div>
        </div>
        <!-- COD CARD -->
        <div class="row pr-3">
          <!--     获取快递公司列表       -->
          <div class="col-12 col-lg-6 col-xl-3 mb-3 pr-2" v-for="item in expressInfoList" :key="item.id">
            <CardPos
                :courier="{
                        ...item
                    }"
                :starShow="false"
                :type="type"
                @click.native="selectSender(item)"
            />
          </div>
        </div>
      </b-card-text>
    </div>
    <!-- 选择寄件人 -->
    <SelectSender ref="modalSender" @addParcelInfo="addParcelInfo"></SelectSender>
    <!-- 添加收件人信息 -->
    <AddParcelInfo @fnGetPosRecentlyList="fnGetPosRecentlyList" ref="addParcelInfo" :cashNumberInfo="cashNumberInfo"  @addParcelInfo="addParcelInfo" :from="from" :activeCourierItem="activeCourierItem" :agentInfo="agentInfo"></AddParcelInfo>
  </div>
</template>
<script>
import NotiPos from "@/components/custom/pos/NotiPos.vue";
import CardPos from "@/components/CardPos.vue";
import {expressList, queryPosExpress} from "@/api/express";
import SelectSender from "@/views/Pos/components/SelectSender.vue";
import AddParcelInfo from "@/views/Pos/components/addParcelInfo.vue";
export default{
  components:{
    AddParcelInfo,
    SelectSender,
    CardPos,
    NotiPos
  },
  props:{
    showCart:{
      type:String,
      default:'',
    },
    agentInfo:{
      type:Object,
      default:() => {},
    },
    cashNumberInfo:{
      type:Object,
      default:() => {},
    },
  },
  data(){
    return {
      type:'Courier',
      searchCourier: '',
      iconDraft: {
        url: require("../../../assets/icon/Drafts.svg")
      },
      expressInfoList:[],
      activeCourierItem:{},
      from: {
        source: 0,
        address: "",
        district: "",
        latlng: "",
        name: "",
        postcode: "",
        province: "",
        state: "",
        tel: "",
        email: "",
        areaCode:''
      },
      busy:false
    }
  },
  created(){
    this.getExpressList()
  },
  methods:{
    countDraft() {
      return  this.draftStorage?Object.keys(this.draftStorage).length:0
    },
    fnGetPosRecentlyList(key) {
      this.$emit('fnGetPosRecentlyList')
    },
    draftLength() {
      return this.draftStorage?Object.keys(this.draftStorage).length > 0:false;
    },
    // 获取快递公司列表
    getExpressList(){
      this.busy = true
      queryPosExpress()
          .then((res) => {
            console.log(res)
            this.expressInfoList = res.data
            this.busy = false
          })
    },
    // 对比价格
    changeStepPosPage(){

    },
    //   选择寄件人
    selectSender(item){
      if (localStorage.getItem('senderInfo')){
        this.activeCourierItem = item
        this.$refs.addParcelInfo.showAddParcelInfo()
      }else{
        this.$refs.modalSender.showSelectSender()
        this.activeCourierItem = item
      }

    },
    // 添加收件人及包裹信息
    addParcelInfo(){
      console.log('showAddParcelInfo')
      this.$refs.addParcelInfo.showAddParcelInfo()
    }
  }
}
</script>
